import "./App.css";
import ClinicianMenu from "./components/ClinicianMenu";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import Patients from "./pages/PatientPage";
import Devices from "./pages/DevicesPage";
import Settings from "./pages/SettingsPage";
import Profile from "./pages/ProfilePage";
import Header from "./components/Header";
import PatientDetails from "./pages/PatientDetails";
import NewPatient from "./pages/NewPatient";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ProtectedRoute from "./components/ProtectedRoutes";
import Unverified from "./pages/UnverifiedUser";
import AboutUs from "./pages/AboutUs";
import AddExistingPatient from "./pages/AddExistingPatient";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TokenChecker from "./components/TokenChecker";
import PatientNotRegistered from "./pages/PatientNotRegistered";
import SplashWrapper from "./components/SplashWrapper";
import TermsAndConditions from "./pages/T&C";
import ForgotPassword from "./pages/ForgotPassword";

const AuthenticatedLayout = () => (
  <>
    <div
      style={{
        flex: 1,
        borderRight: "1px solid #E0E0E0",
      }}
    >
      <ClinicianMenu />
    </div>
    <div style={{ flex: 4.15, minHeight: "100vh" }}>
      <Header />
      <Outlet />
    </div>
  </>
);

function App() {
  return (
    <div
      className="App"
      style={{ display: "flex", paddingTop: "3rem", position: "relative" }}
    >
      <Router>
        <TokenChecker />
        <Routes>
          <Route
            path="/signin"
            element={
              <SplashWrapper>
                <SignIn />
              </SplashWrapper>
            }
          />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/unverified" element={<Unverified />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AuthenticatedLayout />}>
                <Route path="/" element={<Patients />} />
                <Route
                  path="/patient-not-registered"
                  element={<PatientNotRegistered />}
                />
                <Route path="/myProfile" element={<PatientDetails />} />
                <Route path="/patients" element={<Patients />} />
                <Route path="/devices" element={<Devices />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route
                  path="/terms-and-conditions"
                  element={<TermsAndConditions />}
                />
                <Route path="/signout" element={<SignIn />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route
                  path="/patients/:patientID"
                  element={<PatientDetails />}
                />
                <Route path="/patients/newPatient" element={<NewPatient />} />
                <Route
                  path="/patients/addExistingPatient"
                  element={<AddExistingPatient />}
                />
            </Route>
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
